const url = "https://sys.surfway.online/api/"
// https://surfway.online its webtest.surfway.online
// https://sagro.surfway.online
// https://app.surfway.online
// https://sys.surfway.online
// http://localhost:8000
//const proxyurl = "https://cors-anywhere.herokuapp.com/";
//const url= url1;
const Constent = {
    LOGIN: url+"login",
    PIN: url+"checkPin",
    ADDPIN: url+"addPin",
    CONTACT: url+"getUserList",
    GETPROFILE: url+"getProfile",
    UPDATEPROFILE:url+"updateProfile",
    UPDATEPROFILEIMAGE:url+"updateProfileImage",
    USERUPDATESTATUS:url+"userUpdateStatus",
    DASHBOARDMENUSUMMARY: url+"dashboardMenuSummary",

    CHECKINOUT:url+"checkinout",
    CHECKINOUTPROJECT:url+"checkinout_project",
    GETTIMESTAMPSETTING:url+"get_timestamp_setting",
    UPDATETIMESTAMPSETTING:url+"update_timestamp_setting",
    GETFLEXSCHEMASETTING:url+"get_flexschema_setting",
    UPDATEFLEXSCHEMASETTING:url+"update_flexschema_setting",
    GETALLGROUPS:url+"getAllGroups",
    TIMESTAMPLIST:url+"getDepAllUserTimeStamp",
    TIMESTAMPLISTWithoutGROUP:url+"getDepUserTimeStampWithoutGroup",
    GETPROJECT:url+"getProject",
    PROJECTDETAILS:url+"projectDetails",
    GETPROJECTACTIVITY: url+ "getProjectActivity",
    PROJECTADDCOMMENT: url+ "projectAddComment",
    PROJECTADDMATERIAL: url+ "add_materials",
    SHIFTUSERLIST: url+"shift_get_user_list",
    GETDEPSHIFT:url+"depGetShift",
    GETFSHIFTSCHEDULESETTING:url+"get_shift_setting",
    UPDATESHIFTSCHEMASETTING:url+"update_shift_setting",
    CHANGEDEPARTMENT:url+"changeDepartment",
    GETPROJECTSETTING:url+"get_project_Setting",
    UPDATEPROJECTSETTING:url+"update_project_Setting",
    GETALLPROJECT:url+"depGetProject",
    GETUSERCHATLIST:url+"getUserChatList",
    CHECKUSERCHAT:url+"checkUserChat",
    CHECKGROUPCHAT:url+'checkGroupChat',
    USERTIMESTAMP:url+'getUserTimeStamp',
    ADDPROJECT:url+"addProject",
    UPDATEPROJECT:url+"updateProject",
    GETPROJECTCOMPANIES: url+"getProjectCompanies",
    addProjectCompanies: url+"addProjectCompanies",
    UPDATEPROJECTCOMPANIES: url+"updateProjectCompanies",
    DELETIMESTAME:url+"deleteTimeStamp",
    DELETIMESTAMEDETAIL:url+"deleteTimeStampDetail",
    RESETPIN:url+"resetPin",
    DELETPROJECT:url+"updateProject",
    SHIFT:url+"depGetAssignment",
    ADDSHIFT:url+"depAddShift",
    LASTTIMESTAMPDETAIL : url+"lastTimestampDetail",
    GetTimeStampDetail:url+"getTimeStampDetail",
    ADDTIMESTAMP:url+"addTimestampDetail",
    TERMINALADDTIMESTAMP:url+"terminalAddTimestampDetail",
    ADDTIMESTAMPBREAK:url+"addTimestampBreak",
    UPDATETIMESTAMPBREAK:url+"updateTimestampBreak",
    DELETETIMESTAMPBREAK:url+"deleteTimestampBreak",
    COPYTIMESTAMP:url+"copyTimestampDetail",
    EDITTIMESTAMP:url+"editTimeStampDetail",
    FORGOTPASSWORD:url+"forgot_password",
    DELETESHIFT:url+"depDeleteShift",
    UPDATESHIFT:url+"depUpdateShift",
    GETUSERSHIFT:url+"userGetShift",
    GETUSERTIMESTAMP:url+"getUserTimeStamp",
    FREESHIFT:url+"freeThisShift",
    APPLYFREESHIFT:url+"applyFreeShifts",

    CREWLIST:url+"crew_get_list",
    CREWGETDEPSHIFT:url+"crew_depGetShift",
    CREWGETUSERSHIFT:url+"crew_userGetShift",
    CREWFREESHIFT:url+"crew_freeThisShift",
    CREWAPPLYFREESHIFT:url+"crew_applyFreeShifts",
    CREWDELETESHIFT:url+"crew_depDeleteShift",
    CREWUPDATESHIFT:url+"crew_depUpdateShift",
    CREWADDSHIFT:url+"crew_depAddShift",

    SELECTLANGUAGE:url+"select_language_timestamp",
    SELECTLANGUAGEWEBAPP:url+"select_webapp_language",
    ADDUSER:url+"addUser",
    DEVICELIST : url+"device_list",
    UPDATEDEVICE : url+"update_device",
  //  TERMINALGETTIMESTAMP: url+"terminal_get_timestamp",
    TERMINALGETTIMESTAMP: url+"terminal_get_timestamp_data",
    GETSHAREDEVICEDATA: url+"terminal_get_share_device_data",
    guestShareUpdateSettings: url+"guestShareUpdateSettings",
    SENDMESSAGE: url+"send_message",
    ADDDEPARTMENT: url+"add_department",
    WEBMAILINBOX : url+"webmail_inbox",
    WEBMAILSENTBOX : url+"webmail_sentbox",
    WEBMAILTRASH : url+"webmail_trash",
    SENDMAIL : url + "webmail_send",
    GETALLSCHEMADETAILS : url + "get_schema_details",
    FLEXSHIFT: url + "get_flex_shift",
    FLEXSHIFTUSER: url + "get_flex_shift_foruser",
    FLEXTIMEUSER: url + "get_flex_time_foruser",
    FLEXTPREVIOUSSCHEMALIST: url + "get_previous_flex_schema_list",
    FLEXSETABSENCE: url + "flex_set_absence",
    GETFLEXSCHEMA: url + "get_flex_schema",
    UPDATEFLEXSCHEMA: url + "update_flex_schema",
    FLEXREPORTSUMMERY: url + "flex_get_report_summery",
    FLEXPAYINOUTADD: url + "flex_pay_inout_add",
    FLEXDELETEPAYINOUT: url + "flex_pay_inout_delete",
    GETPACKAGELIST: url + "get_package_list",
    GETPACKAGEDETAILS: url + "get_package_details",
    UPDATEINVOICEMAIL: url + "update_invoice_mail",
    YOURPAYDND: url + "yourpay_dnd",

    GETPUBLICHOLIDAY: url + "get_public_holiday",
    ADDPUBLICHOLIDAY: url + "add_public_holiday",
    UPDATEPUBLICHOLIDAY: url + "update_public_holiday",
    DELETABSENCE : url + "delete_public_holiday",

    GETABSENCESETTING: url + "get_absence_setting",
    UPDATEABSENCESETTING: url + "update_absence_setting",
    GETABSENCE: url + "get_absence_list",
    GETABSENCEUSERLIST: url + "get_absence_user_list",
    getAbsenceDetail: url + "get_absence_details",
    UPDATEABSENCETYPE: url + "update_absence_type",
    ADDABSENCETYPE: url + "add_absence_type",
    DELETABSENCETYPE : url + "delete_absence_type",
    
    GETUSERABSENCETYPE: url + "get_user_absence_type",
    ADDABSENCE: url + "add_absence",
    DELETE_USER_ABSENCE : url + "delete_absence_detail",
    GETTASK:url+"getTaskList",
    GETUSERTASK:url+"getUserTaskList",

    GETTASKDETAILS:url+"taskDetails",
    TASKUPDATE:url+"taskUpdate",
    TASKEDIT:url+"taskEdit",
    TASKATTECHMENTDELETE:url+"deleteTaskAttechment",
    TASKADD:url+"addTask",
    GETDEPARTMENTCONTACT:url+"getAllContactList"




  };
 export default Constent;
